import Model from '@/models/Model'

export default class GBranchOffice extends Model {
    resource() {
        return 'g_branch_office'
    }
}